// extracted by mini-css-extract-plugin
export var blue = "_e-f";
export var brand = "_e-b";
export var darkGrey = "_e-e";
export var disabled = "_e-4";
export var disabledSubtle = "_e-5";
export var error = "_e-6";
export var green = "_e-g";
export var grey = "_e-d";
export var icon = "_e-0";
export var inherit = "_e-a";
export var lightGrey = "_e-c";
export var orange = "_e-i";
export var pink = "_e-k";
export var primary = "_e-1";
export var purple = "_e-l";
export var red = "_e-j";
export var secondary = "_e-2";
export var success = "_e-9";
export var tertiary = "_e-3";
export var warning = "_e-7";
export var warningSecondary = "_e-8";
export var white = "_e-m";
export var yellow = "_e-h";